import React from "react"

export interface TableHelpProps {
  description: string | React.ReactNode
  links?: {
    label: string
    href: string
  }[]
}

function TableHelp(props: TableHelpProps) {
  return (
    // <div className=" bg-[#edf5fd] rounded-xl p-4 flex flex-col gap-3">
    <div className="bordered rounded-xl flex gap-3 bg-slate-50 dark:bg-base-200 dark:border-none my-2">
      {/* <b className="block">Aprenda</b> */}
      {/* <i className="far fa-lightbulb-on text-primary"></i> */}
      <div className="flex flex-col gap-3">
        <p>{props?.description}</p>
        {/* <div className="flex gap-2">
          {props?.links?.map((link) => (
            <a
              className="hover:underline font-medium text-[13px] !text-primary flex items-center gap-2"
              href={link.href}
              target="_blank"
              rel="noreferrer"
              key={link.href}
            >
              <i className="far fa-graduation-cap" />
              {link?.label}
            </a>
          ))}
        </div> */}
      </div>
    </div>
  )
}

export default TableHelp
